module.exports = __webpack_public_path__ + "static/ActaDisplay-ExtraBold-a826903878301be09b216d39075ddcb7.woff2";